import { useQuery } from '@tanstack/react-query'
import { api } from '@/utils/api'
import { apiBundlesId } from '@/utils/api/url'
import { Bundle } from '@/types/bundle'
import { QUERY_KEY_GET_BUNDLES } from './useGetBundles'
import { createRouteForAPI } from '@/utils/helpers/urlHelper'

export const useGetBundle = ({
  enabled = true,
  id,
}: {
  enabled: boolean
  id?: string
}) => {
  const res = useQuery({
    enabled: enabled && !!id,
    queryKey: [QUERY_KEY_GET_BUNDLES, id],
    staleTime: 60 * (60 * 1000), // 60mins
    queryFn: () =>
      api.get(createRouteForAPI(apiBundlesId, { id })).then(({ data }) => {
        const res = data as Bundle
        return res
      }),
  })
  return res
}
